import type { ParsedPowerInputTimeseriesData } from "../types";

export default function calculateLiveSitePhaseCurrentData(
  siteLiveData: ParsedPowerInputTimeseriesData | undefined,
  _selectedSubDistBoardId?: string,
  _selectedCircuitId?: string
): Array<{ name: string; values: Array<{ timestamp: string; usage: number }>; style: { color: string } }> {
  const formatPhaseCurrentData = (data: ParsedPowerInputTimeseriesData["timeseries"] | undefined) => {
    const entries = data != null ? Object.entries(data).filter(([key]) => key !== "__typename" && !key?.includes("In")) : [];
    const phaseNames: Record<string, string> = { Iarms: "Phase 1 (L1)", Ibrms: "Phase 2 (L2)", Icrms: "Phase 3 (L3)" };
    const colors = ["#36c176", "#60acfc", "#ff9800"];
    const twelveHoursAgo = new Date(Date.now() - 12 * 60 * 60 * 1000);
    return entries.map(([key, value], index) => {
      const values = (value ?? [])
        .filter((v) => v?.Time != null && new Date(v.Time) >= twelveHoursAgo && v.max_amps != null)
        .map((v) => ({
          timestamp: new Date(v!.Time).toISOString(),
          usage: v!.max_amps ?? 0,
        }));
      return {
        name: phaseNames[key] ?? key,
        values,
        style: { color: colors[index] ?? "#666" },
      };
    });
  };

  return formatPhaseCurrentData(siteLiveData?.timeseries);
}
